import type { BookChapterRef } from '@/shared/types';

/**
 * How a chapter is named on screen: the author's own heading when the text had one,
 * else its position. The part is added only when the chapter was split, which the
 * caller knows from its siblings.
 */
export function chapterLabel(
  chapter: Pick<BookChapterRef, 'chapterIndex' | 'partIndex' | 'chapterTitle'>,
  split: boolean,
): string {
  const name = chapter.chapterTitle?.trim() || `Chapter ${chapter.chapterIndex + 1}`;
  return split ? `${name} · Part ${chapter.partIndex + 1}` : name;
}

/**
 * What a chapter video is called until it finishes and gets its own title. Only a
 * later part can be known, from the video alone, to be one, so the first part of a
 * split chapter goes by the chapter.
 */
export function untitledChapterName(chapter: Pick<BookChapterRef, 'chapterIndex' | 'partIndex' | 'chapterTitle'>) {
  return chapterLabel(chapter, chapter.partIndex > 0);
}
